import { render, staticRenderFns } from "./ChartSetting.vue?vue&type=template&id=dc2be93c&"
import script from "./ChartSetting.vue?vue&type=script&lang=js&"
export * from "./ChartSetting.vue?vue&type=script&lang=js&"
import style0 from "./ChartSetting.vue?vue&type=style&index=0&id=dc2be93c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports